module.exports = __webpack_public_path__ + "static/media/trailer-5.ad494fb8.png";